<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Login</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">Login</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="notfound thank-you ptb--60">
  <div class="container">
    <div class="row justify-content-center align-items-center text-center">
      <div class="col-12 col-lg-5">
        <div class="contact-form effect8 p-5 border border-warning shadow-lg">
          <form [formGroup]="registerForm" (ngSubmit)="submitForm()" method="post">
            <div class="row gy-3">
              <div class="col-md-12">
                <input type="text" placeholder="Username" formControlName="username" name="username"
                  class="form-control text-secondary" [ngClass]="{ 'is-invalid': submitted && f.username.errors }">
                <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                  <div *ngIf="f.username.errors.required">Username is required</div>
                </div>
              </div>
              <div class="col-md-12">
                <input type="password" placeholder="Password" formControlName="password" name="password"
                  class="form-control text-secondary" [ngClass]="{ 'is-invalid': submitted && f.password.errors }">
                <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                  <div *ngIf="f.password.errors.required">Password is required</div>
                </div>
              </div>
              <div class="col-md-12">
                <button class="cmn-button" type="submit" name="submit">Login</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
